import type {Credentials} from 'aws-sdk';

// Shared constants
export const CHART_MIME_TYPE = 'application/vnd.frida.chart+json';
export const VALID_CHART_TYPES = ['line-chart', 'bar-chart', 'area-chart', 'pie-chart', 'mixed-chart'] as const;
export type ChartType = (typeof VALID_CHART_TYPES)[number];

export const DISCLAIMER_TEXT = 'Cassandra can make mistakes. Check important info.';

// Custom message part types from the Cassandra backend stream
export interface ArtifactPreviewData {
    artifactId: string;
    name: string;
    mimeType: string;
    sizeBytes: number;
    description?: string;
}

export type CustomDataPart =
    | {type: 'data-artifact-previews'; data: ArtifactPreviewData[]}
    | {type: 'data-suggestions'; data: string[]}
    | {type: 'data-tool-parent'; data: {toolCallId: string; parentToolCallId: string}};

/** Type guard for custom data parts */
export function isCustomDataPart(part: {type: string}): part is CustomDataPart {
    return part.type === 'data-artifact-previews' || part.type === 'data-suggestions' || part.type === 'data-tool-parent';
}

/** Shared props passed to ChatMessage for artifact rendering */
export interface ArtifactContext {
    chatId?: string;
    credentials?: Credentials;
    onArtifactClick?: (artifact: {artifactId: string; name: string; mimeType: string}) => void;
}
